import React from "react";
import trans from "../../../../utils";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import { Card, Row, Col, Tag, Typography } from "antd";
const { Text } = Typography;

export default function SnagOfflineData({ formEditData }) {
	const { snags = "" } = formEditData;
	return (
		<>
			<p className="fs-16 fw-700 brand-700 text-uppercase">{trans("Snags")}</p>

			{snags?.map((i, idx) => {
				const severityColor =
					i?.severity === "MINOR"
						? "green"
						: i?.severity === "MAJOR"
							? "yellow"
							: i?.severity === "CRITICAL"
								? "red"
								: "blue";
				return (
					<Card
						key={idx}
						size="small"
						style={{
							marginBottom: 12,
							borderRadius: 8,
							border: "1px solid #beddc5",
						}}
						title={
							<Text strong>
								{trans("Snag")} #{idx + 1}
							</Text>
						}
					>
						<Row gutter={[16, 8]}>
							<Col span={12}>
								<Text type="secondary">{trans("Sector")}</Text>
								<div>{i?.sector || "-"}</div>
							</Col>
							<Col span={12}>
								<Text type="secondary">{trans("Discipline")}</Text>
								<div>{i?.discipline || "-"}</div>
							</Col>
							<Col span={12}>
								<Text type="secondary">{trans("Subsystem")}</Text>
								<div>{i?.subsystem || "-"}</div>
							</Col>
							<Col span={12}>
								<Text type="secondary">{trans("Severity")}</Text>
								<div>
									<Tag color={severityColor}>{i?.severity || "-"}</Tag>
								</div>
							</Col>
							<Col span={12}>
								<Text type="secondary">{trans("Description")}</Text>
								<div>{i?.description || "-"}</div>
							</Col>

							<Col span={12}>
								<Text type="secondary">{trans("Location Details")}</Text>
								<div>{i?.location_details || "-"}</div>
							</Col>

							<Col span={24}>
								<Text type="secondary">{trans("Target Date")}</Text>
								<div>{formatDateString(i?.target_date) || "-"}</div>
							</Col>
						</Row>
					</Card>
				);
			})}
		</>
	);
}
